import { Box, Slider, Typography } from "@mui/material";
import _ from "lodash";
import { brandingColors } from "./utils";
import "./product-tile.css";
import { getTextureValue } from "../data/textures";
import CustomerReviewsComponent from "./product-tile/customer-reviews";
import { Link, useNavigate } from "react-router-dom";

export default function ProductTile({product, question, quizId}:any): JSX.Element {
  // skin type
  let skinTypes : number[] = [1];
  if (product.skinType !== undefined) {
    skinTypes = [];
    _.map(product.skinType, (st) => skinTypes.push(_.toNumber(st)));
  }
  
  const skinTypeMarks = [
    {
      value: 1,
      label: "Oily",
    },
    {
      value: 2,
      label: "Combi-Oily",
    },
    {
      value: 3,
      label: "Combi-Dry",
    },
    {
      value: 4,
      label: "Dry",
    },
  ];

  const getSkinTypeMarks = () => {
    const result : any[] = [];
    if (skinTypes.length > 0) {
      _.map(skinTypes, (st) => result.push(skinTypeMarks[st-1]));
    }
    return result;
  }

  // texture
  const texture = getTextureValue(product);
  const getTextureLabel = (product: any): any => {
    return [
      {
        value: getTextureValue(product),
        label: product.texture,
      }
    ];
  };

  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/product?code=${product.code}`, { state: { quizId: quizId, question: question } });
  }

  return (
    <Box className="product-tile">
      <Box className="product-wrapper"
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", md: "column" },
          justifyContent: "space-around",
        }}
      >
        {/* image */}
        <Box className="left"
          sx={{
            width: "100%",
            cursor: "pointer",
          }}
          onClick={handleClick}
        >

            <img className="product-image"
              alt=""
              src={`https://d3meuv9j0uoyqk.cloudfront.net/${_.trim(
                 _.trim(_.head(_.split(product.imageLocation, ",")))
              )}`}
              style={{ objectFit: "cover" }}
          />

          {/* shopping cart */}
          <a className="shopping-cart" href={product.link} target="_blank">
              <img
                alt=""
                src="/assets/shopping_cart.svg"
                width="18px"
                style={{ objectFit: "cover" }}
              />
          </a>
      
          
        </Box>

        <div className="right">
          <Box className="name">
            <Box className="product-tile-name">
              <h4 className="brand">
                {product.brand}
              </h4>
              <h3 className="product-name" onClick={handleClick}>
                {product.name}
              </h3> 
            </Box>
          </Box>

          <div className="price">
            <span>{product.price}</span>
          </div>

          
          <div className="rating-cart">
            {/* rating */}
            {product.rating ? (
            <div className="rating">
              <img src="/assets/icon-star.png"/>
              <span>{product.rating}</span>
            </div>) : (<div className="rating"></div>)}
            <button className="btn-details" 
              onClick={handleClick}>
              Details
            </button>
          </div>
          
          <Box sx={{ display: { xs: "none", sm: "flex" } }}>
            <CustomerReviewsComponent product={product} />
          </Box>
          
        </div>
        
        
        
        {/*{product['pick'] === undefined ? '' : 
        <Box className="producttile-flag">
          <Box className="text-flag-wrapper">
            <Box className="text-flag">
              <svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
              <span className="text-flag-label">Pick</span>
            </Box>
          </Box>
        </Box>}*/}
      </Box>

      <Box sx={{ display: { xs: "flex", sm: "none" } }}>
        <CustomerReviewsComponent product={product} />
      </Box>

      {/*<div className="info">
            <Box className="skin-type">
              Skin Type
              <Box className="sliders">
                <Box className="slider">
                  <Slider
                    disabled
                    defaultValue={skinTypes}
                    step={1}
                    min={0.8}
                    max={4}
                    marks={getSkinTypeMarks()}
                    color="secondary"
                  />
                </Box>
              </Box>
            </Box>
            <Box className="texture">
            Texture
            <Box className="sliders">
              <Box className="slider">
                <Slider
                  disabled
                  defaultValue={texture}
                  step={1}
                  min={0.3}
                  max={8}
                  color="secondary"
                  marks={getTextureLabel(product)}
                ></Slider>
              </Box>
            </Box>
          </Box>
        </div>*/}

      
    </Box>
  )
}